module.exports = __webpack_public_path__ + "img/gt.452e4b85.svg";